export default "__VITE_ASSET__WYLHp$Ag__"